import React, { Component } from "react";
import { api } from "../helpers";
import Alert from "react-s-alert";
import Select from "react-select";

export default class EquipmentTypeahead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      options: []
    };
    this.loadOptions = this.loadOptions.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  loadOptions(inputValue) {
    if (!inputValue || !inputValue.length || inputValue.length < 3) {
      return;
    }
    api.post("Equipment/EquipmentTypeahead", JSON.stringify(inputValue))
      .then(response => {
        const options = response.data;
        this.setState({ options: options })
      }).catch(error => Alert.error("There was an error loading ."));
  };

  handleInputChange(inputValue) {
    this.setState({ inputValue }, () => { this.loadOptions(inputValue); });
  };

  render() {
    return (
      <div>
        <Select
          options={this.state.options}
          onInputChange={this.handleInputChange}
          onChange={(e) => this.props.onChange(e, this.props.index)}
          value={this.props.selectedOption}
          isDisabled={this.props.disabled}
          id={this.props.id}
          onFocus={this.props.onFocus}
          classNamePrefix={this.props.placeholder}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EquipmentTypeahead.js